import { lazy } from 'react';

export const AdminLogin = lazy(() => import("./Login/index.page"));
export const Dashboard = lazy(() => import("./Dashboard/index.page"));
export const AdminSignup = lazy(() => import("./Signup/index.page"));
export const AdminVerification = lazy(() => import("./Verificationotp/index.page"))
export const VendorProfile = lazy(() => import("./Vendorprofile/index.page"))
export const Forgotpassword = lazy(() => import("./Forgotpassword/index.page"))
// export const Forgototp = lazy(()=>import("./Forgototp/index.page")) 
export const Resetpassword = lazy(() => import("./Resetpassword/index.page"))
export const AddTripList = lazy(() => import("./AddTripList/index.page"))
export const AddTrip = lazy(() => import("./AddTrip/index.page"))
// export const EditTrip = lazy(()=>import("./EditTrip/index.page")) 
export const TripViewDetails = lazy(() => import("./TripViewDetails/index.page"))
export const BookingTripList = lazy(() => import("./BookingTripList/index.page"))
export const BookingViewDetails = lazy(() => import("./BookingViewDetails/index.page"))
export const PaymentList = lazy(() => import("./PaymentList/index.page"))
export const ReportList = lazy(() => import("./ReportList/index.page"))
export const Support = lazy(() => import("./Support/index.page"))
export const CMS = lazy(() => import("./CMS/index.page"))
export const MyProfile = lazy(() => import("./MyProfile/index.page"))
export const EditProfile = lazy(() => import("./EditProfile/index.page"))
export const ReviewList = lazy(() => import("./ReviewList/index.page")) 